export enum MenuMode {
  STATIC = 'static',
  OVERLAY = 'overlay',
  SLIM = 'slim',
  SLIM_PLUS = 'slim-plus',
  HORIZONTAL = 'horizontal',
  POPUP = 'popup',
  REVEAL = 'reveal',
  DRAWER = 'drawer'
}

export enum ColorScheme {
  LIGHT = 'light',
  DARK = 'dark'
}

export enum MenuTheme {
  LIGHT = 'light',
  DARK = 'dark',
  INDIGO = 'indigo',
  BLUEGREY = 'bluegrey',
  BROWN = 'brown',
  CYAN = 'cyan',
  GREEN = 'green',
  DEEPPURPLE = 'deeppurple',
  DEEPORANGE = 'deeporange',
  PINK = 'pink',
  PURPLE = 'purple',
  TEAL = 'teal'
}

export enum ComponentTheme {
  INDIGO = 'indigo',
  PINK = 'pink',
  PURPLE = 'purple',
  DEEPPURPLE = 'deeppurple',
  BLUE = 'blue',
  LIGHTBLUE = 'lightblue',
  CYAN = 'cyan',
  TEAL = 'teal',
  GREEN = 'green',
  LIGHTGREEN = 'lightgreen',
  LIME = 'lime',
  YELLOW = 'yellow',
  AMBER = 'amber',
  ORANGE = 'orange',
  DEEPORANGE = 'deeporange',
  BROWN = 'brown',
  BLUEGREY = 'bluegrey'
}

export enum TopbarTheme {
  LIGHTBLUE = 'lightblue',
  DARK = 'dark',
  WHITE = 'white',
  BLUE = 'blue',
  DEEPPURPLE = 'deeppurple',
  PURPLE = 'purple',
  PINK = 'pink',
  CYAN = 'cyan',
  TEAL = 'teal',
  GREEN = 'green',
  LIGHTGREEN = 'lightgreen',
  LIME = 'lime',
  YELLOW = 'yellow',
  AMBER = 'amber',
  ORANGE = 'orange',
  DEEPORANGE = 'deeporange',
  BROWN = 'brown',
  GREY = 'grey',
  BLUEGREY = 'bluegrey',
  INDIGO = 'indigo'
}

export enum MenuProfilePosition {
  START = 'start',
  END = 'end'
}

export enum InputStyle {
  OUTLINED = 'outlined',
  FILLED = 'filled'
}
